if (!customElements.get('nbr-flavour-compare')) {
  customElements.define(
    'nbr-flavour-compare',
    class NbrFlavourCompare extends HTMLElement {
      connectedCallback() {
        this.toggles = Array.from(this.querySelectorAll('[data-flavour-toggle]'));
        this.panelWrap = this.querySelector('[data-flavour-panel-wrap]');
        this.panels = Array.from(this.querySelectorAll('[data-flavour-panel]'));
        this.openIndex = null;

        this.toggles.forEach((btn) => {
          btn.addEventListener('click', () => this.select(btn.dataset.flavourToggle));
        });
      }

      select(index) {
        const isSame = this.openIndex === index;

        this.toggles.forEach((btn) => {
          const active = btn.dataset.flavourToggle === index && !isSame;
          btn.setAttribute('aria-expanded', active ? 'true' : 'false');
          btn.textContent = active ? 'Hide What’s Inside −' : 'See What’s Inside +';
        });

        if (isSame) {
          this.openIndex = null;
          if (this.panelWrap) this.panelWrap.hidden = true;
          return;
        }

        this.openIndex = index;
        this.panels.forEach((panel) => {
          panel.hidden = panel.dataset.flavourPanel !== index;
        });
        if (this.panelWrap) {
          this.panelWrap.hidden = false;
          this.panelWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      }
    }
  );
}
